export default {
  Geolocate: new Event('geolocate'),
  GeolocateLoaded: new Event('geolocate-loaded'),
  GeolocateFailed: new Event('geolocate-failed'),
  GeolocateDisabled: new Event('geolocate-disabled'),

  Geolocated(data) {
    return new CustomEvent('geolocate-success', {
      detail: data,
    });
  },
};
